module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-34-min.9d082d66.jpg";